/* Global UX behaviours: back-to-top button + scroll-reveal animations. */
(function () {
  'use strict';

  /* ---- Back to top ---- */
  var btt = document.querySelector('[data-back-to-top]');
  if (btt) {
    var toggle = function () {
      if (window.pageYOffset > 400) { btt.hidden = false; btt.classList.add('is-visible'); }
      else { btt.classList.remove('is-visible'); }
    };
    window.addEventListener('scroll', toggle, { passive: true });
    btt.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    toggle();
  }

  /* ---- Scroll reveal animations ---- */
  if (document.body && document.body.getAttribute('data-animations') === 'true') {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var main = document.getElementById('MainContent') || document.body;
    var targets = Array.prototype.slice.call(main.querySelectorAll('.shopify-section')).filter(function (el) {
      return !el.querySelector('[data-sticky-atc]') && !el.id.includes('sticky');
    });
    if (targets.length) {
      document.documentElement.classList.add('anim-ready');
      targets.forEach(function (el) { el.setAttribute('data-animate', ''); });
      if (reduce || !('IntersectionObserver' in window)) {
        targets.forEach(function (el) { el.classList.add('is-in'); });
      } else {
        var io = new IntersectionObserver(function (entries, obs) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) { entry.target.classList.add('is-in'); obs.unobserve(entry.target); }
          });
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.04 });
        targets.forEach(function (el) { io.observe(el); });
      }
    }
  }

  /* ---- Cookie consent banner ---- */
  var cookie = document.querySelector('[data-cookie-banner]');
  if (cookie) {
    var seen = false;
    try { seen = !!localStorage.getItem('cookie_consent_v2'); } catch (e) {}
    if (!seen) cookie.hidden = false;
    cookie.querySelectorAll('[data-cookie-accept]').forEach(function (b) {
      b.addEventListener('click', function () {
        try { localStorage.setItem('cookie_consent_v2', '1'); } catch (e) {}
        cookie.hidden = true;
      });
    });
  }

  /* ---- Product card countdown timers (metafield custom.timmer) ---- */
  var cardTimers = document.querySelectorAll('[data-card-timer]');
  if (cardTimers.length) {
    var pad2 = function (n) { return n < 10 ? '0' + n : '' + n; };
    var tickCard = function (el) {
      var end = new Date(el.getAttribute('data-end')).getTime();
      var diff = end - Date.now();
      if (isNaN(end) || diff <= 0) { el.hidden = true; return true; }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      var txt = el.querySelector('[data-card-timer-text]');
      if (txt) txt.textContent = (d > 0 ? d + 'd ' : '') + pad2(h) + ':' + pad2(m) + ':' + pad2(s);
      el.hidden = false;
      return false;
    };
    cardTimers.forEach(function (el) {
      if (tickCard(el)) return;
      var id = setInterval(function () { if (tickCard(el)) clearInterval(id); }, 1000);
    });
  }
})();
